import { render, staticRenderFns } from "./scrollBar.vue?vue&type=template&id=39361b28&scoped=true&"
import script from "./scrollBar.vue?vue&type=script&lang=js&"
export * from "./scrollBar.vue?vue&type=script&lang=js&"
import style0 from "./scrollBar.vue?vue&type=style&index=0&id=39361b28&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39361b28",
  null
  
)

export default component.exports